/*账号接口*/
import {postAjaxRequest} from '@/utils/request'

// 账号密码/验证码登录
export function AccountLogin(parm, callback) {
	console.log('AccountLogin');
	postAjaxRequest('/AccountAPI/AccountLogin', parm, function(result) {
		callback(result);
	})	
}
//登录
export function accountLoginByOrganizaType(parm, callback) {
	console.log('accountLoginByOrganizaType');
	postAjaxRequest('/AccountAPI/AccountLoginByOrganizaType', parm, function(result) {
		callback(result);
	})	
}
//根据账号登录
export function GetLoginByUserCode(parm, callback) {
	console.log('GetLoginByUserCode');
	postAjaxRequest('/AccountAPI/GetLoginByUserCode', parm, function(result) {
		callback(result);
	})	
}


